import { useRMSelector } from 'redux/hooks';
import { selectExp } from 'redux/selectors/ExperimentStateSelector';

const usePlateGenerated = () => {
  const experimentData = useRMSelector(selectExp);
  return experimentData?.plateDto?.some((plate) => plate.plateId > 0);
};

export default usePlateGenerated;
